import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ArticlePost } from '../../shared/interfaces/index.interface';
import { JwtService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class FeedService {
  readonly BASE_URL = environment.BASE_API_URL;
  constructor(
    private http:HttpClient,
    private jwtService:JwtService,
  ) {}
  
  getAllMagezinePost(page:number=1){
    return this.http.get<ArticlePost>(this.BASE_URL+`post/?content_type__app_label=magazine&content_type__model=magazine&page=${page}&ordering=-publish_date`);
  }
  getBestVisitorPosts(){
    return this.http.get(`${this.BASE_URL}magazine/best/visitors`)
  }
}